// src/app/custom-date-adapter.ts
import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  parse(value: string): Date | null {
    const [day, month, year] = value.split('/').map(val => parseInt(val, 10));
    return new Date(year, month - 1, day);
  }

  format(date: Date, displayFormat: string): string {
    if (!date) {
        return '';
      }
  
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
  }


